var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShotEyesImage = function SvgShotEyesImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "shotEyesImage_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".shotEyesImage_svg__st0{fill:none;stroke:#333;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5c0-.6.4-1 1-1h17c.6 0 1 .4 1 1v14c0 .6-.4 1-1 1h-17c-.6 0-1-.4-1-1z",
    className: "shotEyesImage_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 9c.5 0 .8-.3.8-.8s-.3-.7-.8-.7-.7.3-.7.7.3.8.7.8",
    className: "shotEyesImage_svg__st0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 12 2.5 2 3-3.5 8.5 6.5v2c0 .6-.4 1-1 1h-17c-.6 0-1-.4-1-1v-2z",
    style: {
      fill: "none",
      stroke: "#333",
      strokeWidth: 1.5,
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }));
};
export default SvgShotEyesImage;